// extracted by mini-css-extract-plugin
export default {"box":"style--box--ee0b9f","separated":"style--separated--1d6bef"};